import { useState } from "react";
import { notification, Dropdown, Menu, Button, Modal } from "antd";
import { DeleteOutlined, ArrowRightOutlined, BarsOutlined, ShareAltOutlined } from "@ant-design/icons";
import moment from "moment";
import { useSelector } from "react-redux";
import { Translate } from "../../translate";
import DateTime from "../DateTime";
import { getStore } from "../../utils/global";
import axios from "../../utils/axios";
import SelectContacts from "../upload/SelectContacts";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";

const { confirm } = Modal;
const DraftCard = ({ data, refetch }) => {
  const [visible, setVisible] = useState(false);
  const history = useHistory();
  const [contactChooserOpen, setContactChooserOpen] = useState(false);

  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  const useTemplate = () => {
    history.push(`/drafts/1/0/${data.id}`);
  };

  const handleVisible = () => {
    setContactChooserOpen(!contactChooserOpen);
    setVisible(false);
  };

  const onOk = (data) => {
    if (!data.id) {
      notification.error({
        message: "Please select from Favourite contacts!",
        duration: 3,
      });
      return 1;
    }
    shareTemplate(data.id);
  };

  const { mutate: deleteTemplate, isLoading } = useMutation({
    mutationKey: ["delete_template"],
    mutationFn: (id) => {
      return axios.post("client/api/doc/template/delete", { id }, { showSuccessMessage: true, showErrorMessage: true });
    },
    onSuccess: ({ success }) => {
      if (success) {
        refetch();
      }
    },
  });

  const { mutate: shareTemplate } = useMutation({
    mutationKey: ["share_template"],
    mutationFn: (user_id) => {
      return axios.post(
        "client/api/doc/template/share",
        {
          user_id: user_id,
          template_id: data.id,
        },
        { showSuccessMessage: true, showErrorMessage: true },
      );
    },
    onSuccess: ({ success }) => {
      if (success) {
        handleVisible();
      }
    },
  });

  useSelector((state) => state.draft.parts);

  const handleDelete = () => {
    confirm({
      title: "Confirm Delete",
      content: Translate[ln].Settings.DeleteConfirm,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        deleteTemplate(data.id);
      },
    });
  };

  return (
    <div className="template">
      <div className="template_banner">
        <SelectContacts isOpen={contactChooserOpen} onCancel={handleVisible} onSelect={onOk} />
        <Dropdown
          onOpenChange={() => setVisible(!visible)}
          open={visible}
          trigger={["click"]}
          overlay={
            <Menu>
              <div className="template_drop">
                <div onClick={handleVisible}>
                  <ShareAltOutlined />
                  {Translate[ln].Drafts.Share}
                </div>
              </div>
            </Menu>
          }>
          <div className="temp_ellipsis">
            <BarsOutlined />
          </div>
        </Dropdown>
        <div className="template_title">
          <span>{data?.name ?? "Title"}</span>
        </div>
        <span
          style={{
            fontSize: "12px",
            textTransform: "none",
            fontWeight: "lighter",
          }}>
          <DateTime value={moment(data.create_date?.date)} />
        </span>
      </div>

      <div className="template_info">
        <div className="template_info_double">
          <div className="template_info_double">
            <span> {Translate[ln].Drafts.Participants}:</span>
            <span>{data?.signers_count}</span>
          </div>
        </div>
        <div className="template_info_footer">
          <Button icon={<DeleteOutlined />} onClick={handleDelete} danger type="primary" loading={isLoading} />
          <Button onClick={useTemplate}>
            {Translate[ln].Drafts.View} <ArrowRightOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DraftCard;
